const ROUTES_NAMES = {
  OVERVIEW: 'Overview',
  COMMITTEES: 'Committees',
};

export default ROUTES_NAMES;
